import { lazy } from 'react';

const CustomPlanificationsObjectivesNewContract = lazy(() => import('./CustomPlanificationsObjectivesNewContract'));

export default CustomPlanificationsObjectivesNewContract;
